module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "chat-display"
  }, [(_vm.user.id === _vm.messageData.from) ? _c('div', {
    staticClass: "box right"
  }, [_c('div', {
    staticClass: "msg-content user-msg"
  }, [_c('div', {
    staticClass: "dialog-arrow-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "timestamp left"
  }, [_vm._v(_vm._s(_vm.getTimeStamp))]), _vm._v(" "), _c('div', {
    staticClass: "sender-name user",
    on: {
      "click": _vm.openCard
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('div', {
    staticClass: "msg-text black"
  }, [_vm._v(_vm._s(_vm.messageData.message))])])]) : _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "picture-icon",
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": _vm.openCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-content contact-msg"
  }, [_c('div', {
    staticClass: "timestamp right"
  }, [_vm._v(_vm._s(_vm.getTimeStamp))]), _vm._v(" "), (_vm.person) ? _c('div', {
    staticClass: "sender-name black",
    on: {
      "click": _vm.openCard
    }
  }, [_vm._v(_vm._s(_vm.person.firstName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "msg-text"
  }, [_vm._v(_vm._s(_vm.messageData.message))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-arrow"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd5e644","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatBox.vue
// module id = 463
// module chunks = 0